(function () {
    'use strict';
    var findMyMusic = {

        controller: function ($rootScope, notifications, inlineSearchResults, displayLoading, $timeout) {
            var vm = this;
            
            vm.genreTags = [{ genre: 'edm', name: 'EDM'},{ genre: 'pop', name: 'Pop'},{ genre: 'rap', name: 'Rap'},{ genre: 'dance', name: 'Dance'},{ genre: 'rock', name: 'Metal'},{ genre: 'hiphop', name: 'Hip Hop'},{ genre: 'j-pop', name: 'J-pop'},{ genre: 'k-pop', name: 'K-pop'},{ genre: 'classical', name: 'Classical'},{ genre: 'electronic', name: 'Electronic'},{ genre: 'alternative', name: 'Alternative'},{ genre: 'rnb', name: 'RNB'},{ genre: '80s', name: '80s'},{ genre: '90s', name: '90s'},{ genre: 'indie', name: 'Indie'}];

            vm.personalisedMusicUser = {
                firstName: $rootScope.userDetails.name.split(' ')[0],
                avatar: $rootScope.userDetails.avatar
            }

            vm.genreChoice = vm.genreTags;
            vm.generSelected = [];
            vm.artistSelected = [];

            vm.startFindingMusic = function(e) {
                e.preventDefault();
                angular.element('.stepOneFindMyMusic').hide();
                angular.element('.stepTwoFindMyMusic').show();
            }
    
            vm.addGenrefilter = function(event, genre) {
                
                var filterIndex = vm.generSelected.indexOf(genre);
                if (filterIndex >= 0) {

                    vm.generSelected.splice(filterIndex, 1);
                    angular.element(event.target).attr('class', 'alignItems');

                    if (filterIndex < 3) {
                        angular.element('#findMyMusic .stepTwoFindMyMusic .profileStart').hide();
                    }

                } else {

                    if (vm.generSelected.length <= 2) {

                        vm.generSelected.push(genre);

                        angular.element(event.target).attr('class', 'alignItems genreSelected');

                        angular.element('#findMyMusic .stepTwoFindMyMusic .profileStart').hide();

                        if (vm.generSelected.length === 3) {
                            angular.element('#findMyMusic .stepTwoFindMyMusic .profileStart').show();
                        }

                    } else {
                        notifications.messagePrompt('You can only select a maximum of 3 genres!');
                    }
                }
            };

            vm.addArtistfilter = function(event, artistName) {
                
                var filterIndexArtist = vm.artistSelected.indexOf(artistName);

                if (filterIndexArtist >= 0) {

                    vm.artistSelected.splice(filterIndexArtist, 1);
                    angular.element(event.target).attr('class', 'alignItems');

                    if (filterIndexArtist < 10) {
                        angular.element('#findMyMusic .stepThreeFindMyMusic .profileStart').hide();
                    }

                } else {

                    if (vm.artistSelected.length <= 9) {

                        vm.artistSelected.push(artistName);

                        angular.element(event.target).attr('class', 'alignItems artistSelected');

                        angular.element('#findMyMusic .stepThreeFindMyMusic .profileStart').hide();

                        if (vm.artistSelected.length === 10) {
                            angular.element('#findMyMusic .stepThreeFindMyMusic .profileStart').show();
                        }

                    } else {
                        notifications.messagePrompt('You can only select a maximum of 10 Artists!');
                    }
                }

            };

            vm.genreArtistSearch = function(e, genresToCheck) {
                e.preventDefault();

                var musicfyThreeGenres = genresToCheck;
                displayLoading.showLoading();
                angular.element('.stepTwoFindMyMusic').hide();

                //clear any previous search for genres
                genreArtists = [];
     
                inlineSearchResults.genreFindMyArtists(musicfyThreeGenres, '15').then(function(response) {

                    displayLoading.hideLoading();
                    angular.element('.stepThreeFindMyMusic').show();
                    angular.element('#findMyMusic .stepThreeFindMyMusic .profileStart').hide();
                    vm.artistFound = response;

                }, function errorCallback(response) {
                    console.log(response);
                });

            };

            vm.createMyMusic = function(artistSelected) {

                angular.element('.stepThreeFindMyMusic').hide();
                displayLoading.showLoading();

                console.log(artistSelected)
                vm.musicfyArtistsFound = {};

                inlineSearchResults.artistFindMyArtists(artistSelected, '6').then(function(response) { 
                    
                    vm.musicfyArtistsFound = response;
                    displayLoading.hideLoading();
                    angular.element('.stepFourFindMyMusic').show();
                    angular.element('#findMyMusic .stepFourFindMyMusic .profileStart').show();
                    addFoundArtists($rootScope.userDetails.userId, vm.musicfyArtistsFound)

                });

            }

        },
        controllerAs: 'fmm',
        template: `<div id="findMyMusic" class="findMyMusicContainer" ng-controller="menuCtrl as menu">

            <div class="stepOneFindMyMusic">
                <h2>Hello {{ fmm.personalisedMusicUser.firstName }}</h2>
                <p class="profileImg">
                    <img ng-src="{{ fmm.personalisedMusicUser.avatar }}" />
                </p>

                <p class="profileIntro">
                    First off, welcome to Musicfy! Let us know what kind of music you are into and we'll find you some awesome music!
                </p>

                <p class="profileStart">
                    <a href ng-click="fmm.startFindingMusic($event)">Start</a>
                </p>
            </div>
            <div class="stepTwoFindMyMusic">
                <h2>Your Favourite Genres</h2>
                <p class="profileImg">
                    <img ng-src="{{ fmm.personalisedMusicUser.avatar }}" />
                </p>

                <p class="profileIntro">
                    To get the ball rolling, we need to know a few of your favourite genres! Pick 3 to start with.
                </p>

                <p class="profileStart hide-above--desktop">
                    <a href ng-click="fmm.genreArtistSearch($event, fmm.generSelected)">Continue</a>
                </p>

                <ul>
                    <li ng-repeat="genre in fmm.genreChoice track by $index" class="alignItems" ng-click="fmm.addGenrefilter($event, genre.genre)">
             
                        {{ genre.name }}
                        
                    </li>
                </ul>
                <p class="profileStart">
                    <a href ng-click="fmm.genreArtistSearch($event, fmm.generSelected)">Continue</a>
                </p>
            </div>

            <div class="stepThreeFindMyMusic">
                <h2>Your Favourite Artists</h2>
                <p class="profileImg">
                    <img ng-src="{{ fmm.personalisedMusicUser.avatar }}" />
                </p>

                <p class="profileIntro">
                    We've found some artists you may like! Select your favourite 10 from the selection and we will find your the perfect music to match your taste.
                </p>

                <p class="profileIntro">
                    Currently selected <span class="artists-selected"><strong> {{ fmm.artistSelected.length }} </strong></span> artists
                </p>

                <p class="profileStart">
                    <a href ng-click="fmm.createMyMusic(fmm.artistSelected, '5')">Find My Music</a>
                </p>

                <ul>
                    <li ng-repeat="artist in fmm.artistFound track by $index" class="alignItems artistMatch" ng-click="fmm.addArtistfilter($event, artist.name)">
                        <img ng-src="{{ artist.primary }}" />
                        <p>{{ artist.name }}</p>
                    </li>
                </ul>

                <p class="profileStart">
                    <a href ng-click="fmm.createMyMusic(fmm.artistSelected, '5')">Find My Music</a>
                </p>

            </div>

            <div class="stepFourFindMyMusic">
                <h2>We Have A Match!</h2>
                <p class="profileImg">
                    <img ng-src="{{ fmm.personalisedMusicUser.avatar }}" />
                </p>

                <p class="profileIntro">
                    Here are the Artists we have found. Go explore their music!
                </p>

                <!--<p class="profileStart">
                    <a href ng-click="">View Collection</a>
                </p> -->

                <ul>
                    <li ng-repeat="artist in fmm.musicfyArtistsFound track by $index" class="alignItems artistMatch" ng-click="menu.navigatePage('/search/' + artist.name)">
                        <img ng-src="{{ artist.primary }}" />
                        <p ng-click="menu.navigatePage('/search/' + artist.name)">{{ artist.name }}</p>
                    </li>
                </ul>
            </div>
        </div>`
    };

    angular
        .module('app.core')
        .component("findMyMusic", findMyMusic);

})();


(function () {
    'use strict';
    var privacyNotice = {

        controller: function (notifications) {
            var vm = this;
            var privacyWidget = angular.element('#musicfyPrivacy');

            vm.closePrivacy = function () {
                privacyWidget.slideToggle(450);
            }

            vm.acceptPrivacy = function () {
                privacyWidget.hide();
                localStorage.setItem('acceptedPrivacy', true);
                localStorage.setItem('gaSet', true);
            }

            vm.myPreferences = function () {
                angular.element('#musicfyPrivacyPrefs').modal().modal('open');

                vm.gaSettatus = localStorage.getItem("gaSet");
                vm.gaTime = function () {
                    localStorage.setItem("gaSet", vm.gaErino.enabled);
                    vm.gaSettatus = localStorage.getItem('gaSet');
                };

                if (vm.gaSettatus === null) {
                    localStorage.setItem("gaSet", false);
                    vm.gaErino = { enabled: false };
                    vm.gaSettatus = localStorage.getItem('gaSet');
                } else {
                    vm.gaSettatus = localStorage.getItem('gaSet');
                    vm.gaErino = { enabled: JSON.parse(vm.gaSettatus) };
                }
            }

            vm.savePreferences = function () {
                var gaStatus = JSON.parse(localStorage.getItem('gaSet'));
                if (gaStatus !== null) {
                    localStorage.setItem('acceptedPrivacy', true);
                    angular.element('#musicfyPrivacyPrefs').modal().modal('close');
                    angular.element('body').css('overflow', 'inherit');
                    privacyWidget.slideToggle(450);
                    notifications.messagePrompt('Your preferences have been saved!');
                }

            }

            var showPrivacy = JSON.parse(localStorage.getItem('acceptedPrivacy'));
            var privacyCounter = JSON.parse(localStorage.getItem('privacyCounter'));

            if (showPrivacy === null || privacyCounter == null) {
                localStorage.setItem('acceptedPrivacy', false);
                localStorage.setItem('privacyCounter', 1);
                privacyWidget.show();
            }
            //console.log(showPrivacy);
            if (showPrivacy === true) {
                privacyWidget.hide();
            } else {
                switch (privacyCounter) {
                    case 1:
                        localStorage.setItem('privacyCounter', 2);
                        privacyWidget.show();
                        break;
                    case 2:
                        localStorage.setItem('privacyCounter', 3);
                        privacyWidget.show();
                        break;
                    case 3:
                        localStorage.setItem('acceptedPrivacy', true);
                        localStorage.setItem('privacyCounter', 3);
                        localStorage.setItem('gaSet', true);
                        privacyWidget.hide();
                        break;
                }
            }

        },
        controllerAs: 'privacy',
        template: `<div id="musicfyPrivacy">
                        <div class="closePolicy" ng-click="privacy.closePrivacy()">&times;</div>
                        <div class="container alignItems">
                            <div class="privacyIntro">
                                <p>We use analytics tracking to help improve your expreience using Musicfy. Please review your preferences.</p>

                            </div>
                            <div class="privacyCTA">
                                <ul>
                                    <li><a href ng-click="privacy.myPreferences()">View Preferences</a>
                                    <li><a href class="accept" ng-click="privacy.acceptPrivacy()">Accept</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    
                    <div id="musicfyPrivacyPrefs" class="modal small-modal musicfy-modal modal--medium">

                        <a href="#!" class="modal-close musicfy-modal__close">&times;</a>

                        <div class="musicfy-modal__content">

                            <h4>Your Privacy Options</h4>
                            <p>We use Google Analytics to help shape the experience on Musicfy. All data is sent anonymously.</p>
                            
                            <div class="musicfy-modal__content-toggle">

                                <p>Google Analytics</p>

                                <div class="switch">
                                    <label>
                                        Disabled
                                        <input type="checkbox" ng-model="privacy.gaErino.enabled" ng-change="privacy.gaTime()">
                                        <span class="lever"></span>
                                        Enabled
                                    </label>
                                </div>
                                
                            </div>
                        </div>

                        <div class="musicfy-modal__buttons btn-group">

                            <a href="#!" ng-click="privacy.savePreferences()" class="btn musicfyCloseModal">Save Preferences</a>

                        </div>
                    </div>`
    };

    angular
        .module('app.core')
        .component("privacyNotice", privacyNotice);

})();


(function () {
    var searchsongs = {
        controller: function ($location, notifications, $rootScope) {
            var vm = this;
            vm.searchSongerino = function (search) {
                vm.searchQuery = this.query;

                if (vm.searchQuery === undefined || vm.searchQuery === '') {
                    notifications.messagePrompt("Please enter a search term!");
                } else {

                    try {
                        gtag('event', 'Song Search', {
                            'event_category': 'Search Query',
                            'event_label': this.query
                        });
                    } catch (error) {
                        //ga disabled
                    }
                    $rootScope.newSearch = true;
                    $location.url('/search/' + vm.searchQuery);

                    this.query = '';
                }

            };
        },
        controllerAs: 'searchsongs',
        template: `<form id="search" data-ng-submit="searchsongs.searchSongerino()">
        <input id="query" name="q" type="search" placeholder="Search for a song by Artist or Title..." data-ng-model="searchsongs.query" ng-enter="searchsongs.searchSongerino()" class="validate">
        <div class="musicfy-header__search-submit" ng-click="searchsongs.searchSongerino()">
            <i class="material-icons">search</i>
        </div>
    </form>`
    };

    angular
        .module('app.core')
        .component("searchsongs", searchsongs);

})();

(function () {
    'use strict';
    var shareplaylist = {
        controller: function ($rootScope, $scope, $timeout, notifications) {
            var vm = this;

            vm.generino = globalGenres;

            $rootScope.$watch('myPlDeets', function () {
                $timeout(function () {
                    vm.deeterinos = $rootScope.myPlDeets;
                    $scope.$apply();
                });
            });

            vm.submiterino = function (event) {
                event.preventDefault();

                vm.playlistDeets = vm.deeterinos;

                if (vm.genre === undefined || vm.genre === null || vm.playlistTitle === undefined || vm.playlistTitle === null) {
                    notifications.messagePrompt('Please Select a Genre or a Playlist Title');
                } else {

                    var finalPlayListDetails = {
                        playlistID: vm.deeterinos.playlistID,
                        playlistName: vm.playlistTitle,
                        playlistThumb: vm.deeterinos.playlistThumb
                    }
                    console.log(finalPlayListDetails);

                    addGenrePlaylist(vm.genre, JSON.stringify(finalPlayListDetails));
                    notifications.messagePrompt('Your playlist was saved under ' + vm.genre);
                    angular.element('#genreSubmit').modal().modal('close');
                    angular.element('body').css('overflow', 'inherit');

                    try {
                        gtag('event', 'Playlist Shared', {
                            'event_category': 'Genre',
                            'event_label': vm.playlistDeets.genre
                        });
                    } catch (error) {
                        //ga disabled
                    }

                    //reset select to the first option
                    angular.element('#genreSelect').prop("selectedIndex", 0);
                    vm.playlistTitle = null;
                    vm.genre = null;
                }
            }

        },
        controllerAs: 'shareplaylist',
        template: `<div id="genreSubmit" class="modal small-modal musicfy-modal modal--medium">

        <a href="#!" class="modal-close musicfy-modal__close">&times;</a>

        <div class="musicfy-modal__content">
    
            <h4>Share Your Playlist</h4>

            <p><strong>{{ shareplaylist.deeterinos.playlistName }}</strong></p>
            <p>Let other users enjoy your favourite playlists</p>

        </div>

        <div class="musicfy-modal__form">

            <form ng-submit="shareplaylist.submiterino($event)">
            
                <div class="musicfy-form-field">

                    <input id="playlistID" type="hidden" ng-model="shareplaylist.myPlDeets.playlistID">
                    <input id="playlistThumb" type="hidden" ng-model="shareplaylist.myPlDeets.playlistThumb">

                    <label for="playlistTiplaylistNametle" id="playlistTitle" class="musicfy-form-field__label">Enter a title for the playlist</label>

                    <div class="musicfy-form-field__input">
                        <input id="playlistName" type="text" name="playlistTiplaylistNametle" ng-model="shareplaylist.playlistTitle" placeholder="Enter a Playlist Name">
                    </div>
                
                </div>

                <div class="musicfy-form-field">

                    <div class="musicfy-form-field__input">

                        <select id="genreSelect" name="genreSelect" ng-model="shareplaylist.genre" ng-options="c.genre as c.name for c in shareplaylist.generino"><option value="">-- Select a genre --</option></select>

                    </div>

                </div>
            
                <button class="btn btn--full-width">Share Playlist</button>

            </form>    
        </div>
        
    </div>`
    };

    angular
        .module('app.core')
        .component("shareplaylist", shareplaylist);

})();


(function () {
    'use strict';
    var searchPlayer = {
        controller: function ($rootScope, notifications, inlineSearchResults, myFaves, displayLoading, $location) {

            var vm = this;

            vm.showSearchPanel = false;
            vm.toggleSearchPlayer = function () {
                vm.showSearchPanel === false ? vm.showSearchPanel = true : vm.showSearchPanel = false;
                angular.element('body').toggleClass('newSearchFixed');
                //console.log(vm.showSearchPanel);
                if (vm.showSearchPanel === false) {
                    vm.songResults = '';
                    vm.playlistResults = '';
                    vm.query = null;
                }

            }

            $(document).keydown(function(e){
                if (angular.element('.newSearchFixed').length) {
                    if (e.key === "Escape") {
                        angular.element('.searchVis').click();
                    }
                }
            });

            vm.navigatePage = function (path) {
                angular.element('body').removeClass('newSearchFixed');
                $location.url(path);
            };

            vm.isFavourite = function (id) {
                //Null protection (Never go in without a skin)
                if ($rootScope.upcoming === undefined || $rootScope.upcoming === 0) {
                    return false;
                }
                //Check for song in favSongs
                var i;
                for (i = $rootScope.upcoming.length - 1; i >= 0; i--) {
                    if ($rootScope.upcoming[i].id === id) {
                        return true;
                        break;
                    }
                }
            };

            vm.faveButton = function (event, id, title, thumbnail, type) {
                currentLoginStatus === false ? notifications.messagePrompt("Login to favourite music") : myFaves.faveSong(event, id, title, thumbnail, type);
            }

            vm.searchSongerino = function (search) {

                vm.searchQuery = vm.query;

                if (vm.searchQuery === undefined || vm.searchQuery === '' || vm.searchQuery === null) {
                    notifications.messagePrompt("Please enter a search term!");
                    vm.songResults = '';
                    vm.playlistResults = '';
                } else {

                    vm.songResults = '';
                    vm.playlistResults = '';
                    try {
                        gtag('event', 'Song Search', {
                            'event_category': 'Search Query',
                            'event_label': this.query
                        });
                    } catch (error) {
                        //ga disabled
                    }

                    displayLoading.showLoading();
                    inlineSearchResults.getSearchResulterino(vm.searchQuery).then(function (response) {
                        vm.songResults = response.music;
                        vm.isFavourite();
                        displayLoading.hideLoading();
                    });

                }

            };
        },
        controllerAs: 'searchPlayerSongs',
        template: `<a href ng-click="searchPlayerSongs.toggleSearchPlayer()" class="button-search" ng-class="{ searchVis: searchPlayerSongs.showSearchPanel }">
            <i class="material-icons">search</i>
        </a>
        
        <div id="searchConsole" class="" ng-show="searchPlayerSongs.showSearchPanel">
            <!--<div class="closeSearch" ng-click="searchPlayerSongs.toggleSearchPlayer()">
                <i class="material-icons">close</i>
            </div>-->
            <form id="search" data-ng-submit="searchPlayerSongs.searchSongerino()">
                <div class="input-field musicfy-search-container">
                    <input autocomplete="off" id="query" name="q" type="search" placeholder="Search for a song by Artist or Title..." data-ng-model="searchPlayerSongs.query"
                        ng-enter="searchPlayerSongs.searchSongerino()" class="validate">
                    <div class="submitButton" ng-click="searchPlayerSongs.searchSongerino()">
                        <i class="material-icons">search</i>
                    </div>
                </div>
            </form>

            <div id="results" class="defaultSearch">

                <div class="noResultsMessage" ng-hide="searchPlayerSongs.songResults.length > 0">
                    <h2>Find your favourite track</h2>
                    <p>Start building your queue by searching for your favourite music by entering the artist or song title</p>
                </div>

                <!--<input id="tab1" type="radio" name="tabs" checked>
                <label ng-show="searchPlayerSongs.songResults.length > 0" for="tab1">Songs</label>
                    
                <input id="tab2" type="radio" name="tabs">
                <label ng-show="searchPlayerSongs.songResults.length > 0" for="tab2">Playlists</label>-->

                <section id="miniSearchBox">
                
                    <div id="playlist">

                        <div class="musicfy-playlist-expanded miniSearchContainer">

                            <table>
                                <thead>
                                    <tr>
                                        <!--<th class="songIndex">#</th>-->
                                        <th class="faveHeart"></th>
                                        <th class="songThumbnail"></th>
                                        <th class="trackInfo">Track</th>
                                        <th class="artistInfo">Artist</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr id="songId_{{ $index }}" data-ng-repeat="video in searchPlayerSongs.songResults" ng-class="{activeSong: currentSongId === video.id }">
                                        <td class="faveHeart">
                                            <div class="favSongsSearch">
                                                <div class="favContainer">
                                                    <div data-ng-click="searchPlayerSongs.faveButton($event, video.id, video.title, video.thumbnail, 'list')" ng-class="searchPlayerSongs.isFavourite(video.id) ? 'ion-ios-heart' : 'ion-ios-heart notHearted'"></div>
                                                </div>
                                            </div>
                                        </td>
                                        <td class="songThumbnail">
                                            <div class="prevImg alignItems" data-ng-click="launch(video.id, video.title, $index)">
                                                <img class="video-image" data-ng-src="{{ video.thumbnail }}" data-ng-click="launch(video.id, video.title, $index)" />
                                            </div>
                                        </td>
                                        <td class="trackInfo" data-ng-click="launch(video.id, video.title, $index)">
                                            <p class="artistDesktop" ng-if="video.songName == undefined">
                                                {{ video.title }}
                                            </p>
                                            <p class="artistDesktop" ng-if="video.songName != undefined">
                                                {{ video.songName }}
                                            </p>
                                            <p class="artistMobile">

                                                {{ video.songName }}
                                                <span class="artistName">
                                                    {{ video.artist }}
                                                </span>

                                            </p>
                                        </td>
                                        <td class="artistInfo">
                                            <p class="" ng-if="video.artist == undefined">
                                                Not available
                                            </span>
                                            <p class="" ng-if="video.artist != undefined">
                                                <a href ng-click="menu.navigatePage('/search/' + video.artist)">
                                                    {{ video.artist }}
                                                </a>
                                            </p>
                                            
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                </section>        
                
            </div>
        </div>
        `
    };

    angular
        .module('app.core')
        .component("searchPlayer", searchPlayer);

})();

(function () {
    'use strict';

    angular
    .module('app.core')
    .directive('backButton', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {;
                element.bind('click', function () {
                    history.back();
                    scope.$apply();
                });
            }
        }
    });

})();